/**
 * Copyright (C) Techniserv, spol. s r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export default function(message) {
  const errorAlert = document.createElement('div')
  errorAlert.classList.add('gov-alert', 'gov-alert--error', 'gov-icon--reply-all')
  errorAlert.role = 'alert'

  const alertContent = document.createElement('div')
  alertContent.classList.add('gov-alert__content')

  const alertText = document.createElement('p')
  if (!message) {
    alertText.innerText = Liferay.Language.get('articlefeedback.feedbackError')
  } else {
    alertText.innerText = message
  }

  alertContent.append(alertText)
  errorAlert.append(alertContent)

  return errorAlert
}
